/** Date + time of a dose in the viewer's locale (e.g. "09.10.2026, 21:00"). */
export function formatDoseDateTime(iso: string, language?: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  try {
    return new Intl.DateTimeFormat(language || undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
  } catch {
    return date.toLocaleString();
  }
}

/** A plan's local calendar date ('YYYY-MM-DD') in the viewer's locale (e.g. "15.11.2026"). */
export function formatPlanDate(isoDate: string, language?: string): string {
  const date = new Date(`${isoDate}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return isoDate;
  try {
    return new Intl.DateTimeFormat(language || undefined, { dateStyle: 'medium', timeZone: 'UTC' }).format(date);
  } catch {
    return isoDate;
  }
}
